<template>
    <div class="risk-warning">
        <section class="risk-warning__icon">
            <i class="icon icon-warning" />
        </section>
        <section class="risk-warning__content">
            <p class="risk-warning__content-text">
                {{ $t('jurisdictionRequirements.ukRiskWarning.alert.alertDescription') }}
            </p>
            <p class="risk-warning__content-action">
                <translation-string :translation="warningText" />
                <i class="icon icon-chevron" />
            </p>
        </section>
    </div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';
import {
    ServerConfigurationProps,
} from '@shared/types/config';
import translationString from '@webapp/components/translation-string.vue';

export default {
    name: 'risk-warning',
    components: {
        translationString,
    },
    computed: {
        ...mapGetters('serverConfig', ['serverConfigByKey']),

        warningText() {
            return this.$t('jurisdictionRequirements.ukRiskWarning.alert.alertAction', {
                link: this.serverConfigByKey(ServerConfigurationProps.ukRiskWarningLink),
            });
        },
    },
};
</script>

<style lang="scss">
.risk-warning {
    display: flex;
    background: $orange-t-90;
    border-radius: 8px;
    margin-bottom: 20px;

    &__icon {
        display: flex;
        width: 75px;
        background: $orange-t-30;
        border-radius: 8px 0 0 8px;
        align-items: center;
        justify-content: center;

        .icon {
            font-size: 28px;
            color: #fff;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        text-align: left;
        padding: 0 15px;

        &-title {
            font-weight: bold;
        }

        &-action {
            display: flex;
            margin-top: 4px;
            margin-left: auto;

            .translation-string > .translation-string__link {
                color: $black-color;
                cursor: pointer;
                text-decoration: underline;
            }

            .icon {
                font-size: 10px;
                transform: rotate(90deg);
            }
        }
    }
}
</style>